export default __webpack_public_path__ + "static/media/067-praying mantis.8c2a0102.svg";